// extracted by mini-css-extract-plugin
export default {"sideBtn":"profilepopup_sideBtn__BM0Rv","popup":"profilepopup_popup__17oL8","arrowTop":"profilepopup_arrowTop__WOJFN","popupWrapper":"profilepopup_popupWrapper__jFP7z"};